import { fetchFinance } from "utils/api";

export const queryList = async (params) => {
  return await fetchFinance("/action", {
    action: "getDebitApply",
    debitStatus: "FINISHED",
    sort: "updated,desc",
    ...params,
  });
};
